import { Component, inject, OnInit } from '@angular/core';
import { faRobot } from '@fortawesome/free-solid-svg-icons';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-error-page',
	templateUrl: './error-page.component.html',
	styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent implements OnInit {
	private readonly NotificationService = inject(NotificationService);
	private readonly LabelsService = inject(LabelsService);
	private readonly ProfileService = inject(ProfileService);
	protected readonly AuthLoginService = inject(AuthLoginService);
	icons = {
		faRobot: faRobot,
	};

	labels: LabelsInterface = {
		lbl_kb_pontos: 'Score',
		lbl_geral_eita: 'Jeez',
		lbl_nao_conseguimos_acessar_rota: 'We could not access this route',
		lbl_geral_voltar_para_seguranca: 'Back to safety',
		lbl_esqueceu_acessar_ura: '',
		lbl_geral_desconectar: '',
	};

	isDevelop = false;
	bloobInitialSize = 150;
	bloobSize = this.bloobInitialSize;
	bloobCount = 0;
	bloobResetTimer = 5000;
	bloobStarted = false;
	bloobColddown = false;

	constructor() {}

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
		});

		history.replaceState({}, '404', '404');

		if (!environment.staging && !environment.production) {
			this.isDevelop = true;
		}
	}

	backToHome(): void {
		window.location.href = '/';
	}

	bloob(): void {
		if (!this.bloobColddown) {
			this.bloobSize += 5;
			this.bloobCount += 10;
			if (!this.bloobStarted) {
				this.bloobStarted = true;
				setTimeout(() => {
					this.NotificationService.setNotificationMessage(this.labels.lbl_kb_pontos + ': ' + this.bloobCount);
					this.bloobCount = 0;
					this.bloobColddown = true;
					this.bloobStarted = false;

					setTimeout(() => {
						this.bloobColddown = false;
						this.bloobSize = this.bloobInitialSize;
					}, 900);
				}, this.bloobResetTimer);
			}
		}
	}

	logoff(): void {
		const user = this.ProfileService.userData();
		this.AuthLoginService.logoff(user.id, user.idAnalyst);
	}
}
